// One timer chain at a time: start() during a read only resets the window,
// stop() during a read keeps it from rescheduling, and a failed read is
// logged and the chain goes on.
export default function createStatusPoller({
  delays,
  read,
  isStillWaiting,
  onGaveUp,
}) {
  let timer = null
  let nextDelayIndex = null
  let inFlight = false

  function schedule() {
    clearTimeout(timer)
    let delay = delays[nextDelayIndex]
    nextDelayIndex += 1
    timer = setTimeout(poll, delay)
  }

  async function poll() {
    timer = null
    inFlight = true
    try {
      await read()
    } catch (error) {
      console.warn('Could not refresh assignment statuses', error)
    } finally {
      inFlight = false
    }
    if (nextDelayIndex === null) {
      return
    }
    let stillWaiting = isStillWaiting()
    if (stillWaiting && nextDelayIndex < delays.length) {
      schedule()
      return
    }
    stop()
    if (stillWaiting) {
      onGaveUp()
    }
  }

  function start() {
    nextDelayIndex = 0
    if (!inFlight) {
      schedule()
    }
  }

  function stop() {
    clearTimeout(timer)
    timer = null
    nextDelayIndex = null
  }

  return { start, stop }
}
